import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=5a97f21f&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Upload.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Upload.vue
// module id = 2339
// module chunks = 1